export const SIGN_UP_SOURCE = 'sign-up';
export const ACCOUNT_SOURCE = 'account';
export const CHECKOUT_GUEST_SOURCE = 'checkout_guest';
export const APPOINTMENT_BOOKED_GUEST_SOURCE = 'appointment_booked_guest';
